import React from 'react'
import Icon from '../../components/Layouts/Icons'
import Style from "./ImageCrop.module.scss";
import InfiniteDotLoader from '../InfiniteDotLoader';

const Footer = ({ close, image, save, Remove, isLoading }) => {
    return (
        <div className="modal-footer">
            {image &&
                <button className={Style.remove_image} onClick={() => Remove()}>
                    <Icon color="#000" size={19} icon={"icon-trash"} />
                </button>
            }


            <button
                className="btn btn-border-grey px-2"
                onClick={() => close()}
            >
                Cancel
            </button>
            <button
                className="btn btn-primary px-2"
                disabled={!image}
                onClick={() => save()}
            >
                {isLoading ? <InfiniteDotLoader /> : "Confirm"}
            </button>
        </div>
    )
}

export default Footer